import { StorageObjectStatus } from '@shared/storage/data-access';

export interface IMessageInputElement<T> {
  label: string;
  formControlName: keyof T;
}

export interface IMessageSettings {
  MessageSettingsId: string;
  Birthday: string;
  SubscriptionClosed: string;
  SubscriptionRecess: string;
  SubscriptionLocked: string;
  EvaluationExpired: string;
  EntryCustomer: string;
  EntryCustomerPass: string;
  EntryEmployee: string;
  MedicalExamExpired: string;
  OutOfHours: string;
  OutOfEntryTolerance: string;
  PersonInactive: string;
  PersonNotFound: string;
  OutstandingPayment: string;
  PassageAllowed: string;
  PassesExhausted: string;
  ReentryDenied: string;
  MorningExit: string;
  NightExit: string;
  AfternoonExit: string;
  WithoutSubscription: string;
  BlockWithoutReservation: string;
  BlockWithoutEmail: string;
  BlockWithoutAddress: string;
  BlockWithoutPhone: string;
  AccessDaysExceeded: string;
  Operation?: any;
  ValidationResult?: any;
  IsValid?: boolean;
}

export interface IAccessSettings {
  AccessSettingsId: string;
  AllowReentry: boolean;
  AllowAccessWithoutSubscription: boolean;
  BlockDefaultingSales: boolean;
  BlockDefaultingServices: boolean;
  BlockDefaultingSubscriptions: boolean;
  BlockKeyboardCode: boolean;
  BlockWithoutReservation: boolean;
  BlockWithoutEmail: boolean;
  BlockWithoutAddress: boolean;
  BlockWithoutPhone: boolean;
  DaysToReleaseDefaulters: number;
  DaysToReleaseVisitorAccess: number;
  CodeIdentifier: number;
  PlayHappyBirthday: boolean;
  PrintTraining: boolean;
  RegisterAccessLogAfterAccessGatePassage: boolean;
  SecondsToCleanMonitor: number;
  ShowLastNameInIdentification: boolean;
  ShowQRCodeAccess: boolean;
  EnableSpaceAccessPoint: boolean;
  UseLivePickupPanel: boolean;
  UpdatedOn?: string | null;
  Operation?: any;
  ValidationResult?: any;
  IsValid?: boolean;
}

export interface IStandardMessage {
  Birthday: string;
  EvaluationExpired: string;
  PassesExhausted: string;
  EntryCustomer: string;
  EntryCustomerPass: string;
  EntryEmployee: string;
  MedicalExamExpired: string;
  OutOfHours: string;
  OutOfEntryTolerance: string;
  BlockWithoutReservation: string;
  BlockWithoutEmail: string;
  BlockWithoutAddress: string;
  BlockWithoutPhone: string;
  PersonNotFound: string;
  PersonInactive: string;
  OutstandingPayment: string;
  SubscriptionClosed: string;
  SubscriptionLocked: string;
  SubscriptionRecess: string;
  ReentryDenied: string;
  MorningExit: string;
  AfternoonExit: string;
  NightExit: string;
  WithoutSubscription: string;
}

export interface TEntryMessages {
  MessageSettingsId: string;
  EntryCustomer: string | null;
  EntryCustomerPass: string | null;
  EntryEmployee: string | null;
  ReentryDenied: string | null;
}

export interface TExpirationMessages {
  MessageSettingsId: string;
  EvaluationExpired: string | null;
  PassesExhausted: string | null;
  MedicalExamExpired: string | null;
  OutstandingPayment: string | null;
}

export interface TSubscriptionStatusMessages {
  MessageSettingsId: string;
  SubscriptionLocked: string | null;
  SubscriptionClosed: string | null;
  SubscriptionRecess: string | null;
  WithoutSubscription: string | null;
}

export interface TAlertMessages {
  MessageSettingsId: string;
  Birthday: string | null;
  OutOfHours: string | null;
  PersonNotFound: string | null;
  PersonInactive: string | null;
  BlockWithoutReservation: string | null;
  BlockWithoutEmail: string | null;
  BlockWithoutAddress: string | null;
  BlockWithoutPhone: string | null;
}

export interface TExitMessages {
  MessageSettingsId: string;
  MorningExit: string | null;
  AfternoonExit: string | null;
  NightExit: string | null;
}

export interface TAccessControl {
  AccessSettingsId: string;
  DaysToReleaseDefaulters: number;
  DaysToReleaseVisitorAccess: number;
  PrintTraining: boolean;
  BlockDefaultingSales: boolean;
  BlockDefaultingServices: boolean;
  BlockWithoutReservation: boolean;
  BlockWithoutEmail: boolean;
  BlockWithoutAddress: boolean;
  BlockWithoutPhone: boolean;
  BlockKeyboardCode: boolean;
  AllowReentry: boolean;
  AllowAccessWithoutSubscription: boolean;
  CodeIdentifier: number;
  PlayHappyBirthday: boolean;
  RegisterAccessLogAfterAccessGatePassage: boolean;
  SecondsToCleanMonitor: number;
  ShowLastNameInIdentification: boolean;
  ShowQRCodeAccess: boolean;
  EnableSpaceAccessPoint: boolean;
  UseLivePickupPanel: boolean;
  UpdatedOn?: string | null;
}

export type TAccessGroup = {
  Nome?: string;
  Descricao?: string;
  GrupoDeAcessoId?: string;
  AssinaturasIds?: string[];
}

export enum MediaType {
  Image = 1,
  Video = 2,
}

export interface IAdvertisementFile {
  StorageObjectId: string;
  FileName?: string | null;
  Url?: string | null;
  Status: StorageObjectStatus;
}

export interface IAdvertisementMedia {
  AdvertisementMediaId?: string;
  AdvertisementSettingsId?: string | null;
  FileName?: string | null;
  StorageObjectId?: string | null;
  MediaType?: number | null;
  DurationSeconds?: number | null;
  StartOnUtc?: string | null;
  EndOnUtc?: string | null;
  ViewCount?: number | null;
  Title?: string | null;
  Order?: number | null;
  IsEnabled?: boolean | null;
  File?: IAdvertisementFile;
  Operation?: any;
  ValidationResult?: any;
  IsValid?: boolean;
}

export interface IAdvertisementSettings {
  AdvertisementSettingsId?: string;
  IsEnabled?: boolean | null;
  Advertisements?: IAdvertisementMedia[];
  Operation?: any;
  ValidationResult?: any;
  IsValid?: boolean;
}
